import { Card, CompartmentCard } from "@/src/components/cards";
import { openConfirmDialog, openDrawer } from "@/src/components/dialogs";
import { FetchableList } from "@/src/components/fetchableLists";
import StaggeredAnimation from "@/src/components/staggeredAnimationComponent";
import { Input } from "@/src/components/universalInput";
import { UploadSpots } from "@/src/components/uploadSpots";
import { Patient, Radiotherapy } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  getItemId,
  getUserId,
  getUserShortName,
  openToast,
  uid,
} from "@/src/utils/utils";
import moment from "moment";
import { useState } from "react";
import { ReferenceFieldsForm } from "../fields/referenceFieldsForm";
import { getStandardConfidentiality } from "./confidentialitiesHook";

export function RadiotherapiesHistory({ patient }: { patient: Patient }) {
  const [reload, setReload] = useState(0);
  async function openItemDrawer({
    referenceId,
    item,
  }: {
    referenceId: string | null | undefined;
    item: Radiotherapy | null;
  }) {
    let reference = await apiFetch("references", "loadOne", {
      referenceId,
    });
    if (!reference)
      return openToast(
        "error",
        `Erreur lors du chargement de la référence (N° ${referenceId})`
      );

    item ||= {
      creator: getUserId(),
      patient,
      type: "radiotherapy",
      reference,
      confidentiality: getStandardConfidentiality(patient),
      readBy: [getUserId()],

      content: {
        reference,
        fieldAnswers: [],
        creator: getUserId(),
        patient,
        
      },
    };
    let refAnswer = item.content;

    await openDrawer({
      title: reference.name,
      content: (
        <div className="c1 gap10">
          <ReferenceFieldsForm
            patient={patient}
            currentAnswers={refAnswer?.fieldAnswers || []}
            reference={reference}
            onChange={(newValue) => {
              if (!refAnswer) return;
              refAnswer.fieldAnswers = newValue;
            }}
          />
          <Input
            type="textarea"
            name={"conclusion"}
            value={item?.conclusion || ""}
            onChange={(newValue) => {
              if (!item) return;
              item.conclusion = newValue;
            }}
          ></Input>
          <div className="field">
            <div className="label">Pièces jointes</div>
            <UploadSpots
              gridCount={2}
              value={item?.uploads}
              additionalUploadData={{
                patient: getItemId(patient),
              }}
              onChange={(newValue) => {
                if (!item) return;
                item.uploads = newValue;
              }}
            ></UploadSpots>
          </div>
        </div>
      ),
      onConfirm: async () => {
        if (!item) return;
        await apiFetch("radiotherapies", "addOne", { radiotherapy: item });
        setReload((prev) => prev + 1);
      },
    });
  }

  return (
    <CompartmentCard
      title={"Radiotherapies"}
      color="purple"
      onClick={async () => {
        await openItemDrawer({ item: null, referenceId: null });
      }}
    >
      <FetchableList
        queryKey={["RadiotherapiesHistory", patient.id, reload]}
        queryFn={() =>
          apiFetch("radiotherapies", "loadMany", {
            patientId: patient.id,
            parentId: null,
          })
        }
      >
        {(data) => (
          <div className="grid c1 gap10">
            {data?.map((item, index) => {
              return (
                <StaggeredAnimation key={uid()} index={index}>
                  <Card
                    subTitle={getUserShortName(item?.creator) || ""}
                    color="purple"
                    onClick={async () => {
                      await openItemDrawer({
                        item,
                        referenceId: item.reference?.id,
                      });
                    }}
                    onDelete={async () => {
                      await openConfirmDialog({
                        onConfirm: async () => {
                          await apiFetch("general", "deleteAny", {
                            id: item?.id,
                            table: "radiotherapies",
                          });
                          setReload((prev) => prev + 1);
                        },
                      });
                    }}
                  >
                    <div className="gray">
                      {moment(item._date).format("LL HH:mm")}{" "}
                    </div>
                  </Card>
                </StaggeredAnimation>
              );
            })}
          </div>
        )}
      </FetchableList>
    </CompartmentCard>
  );
}
